import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=62b9d924&scoped=true&"
import script from "./my-order.vue?vue&type=script&lang=js&"
export * from "./my-order.vue?vue&type=script&lang=js&"
import style0 from "./my-order.vue?vue&type=style&index=0&id=62b9d924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9d924",
  null
  
)

export default component.exports